import styled from "styled-components";
import { Space } from "antd";
import { IMG_WHEEL_BG, SpinContainerBg, RefreshOutlined } from "@assets";

export const RootContainer = styled.div`
	position: relative;
	height: 100vh;
	overflow: hidden;
	background-color: #FFF !important;
`;
export const RefreshIcon = styled(RefreshOutlined)`
	font-size: 24px;
	color: #fff;
`;

export const DailyWinnerListContainer = styled.div`
	margin: 291px 0 0 0;
	flex-direction: column;
	align-items: center;

	@media screen and (min-width: 400px) {
		margin: 298px 0 0 0;
	}
`;

export const EmptyTextWrapper = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Title = styled.div`
	text-align: center;
	
	color: #5D5189;
	font-size: 16px;
	font-weight: 500;
	line-height: 18px;
	margin-bottom: 9px;
	@media (min-height: 735px) and (max-height: 745px) {
		margin-bottom: 0px;
	}
`;

export const Number = styled.div`
	margin: 7px 0;
	padding: 12px;
	width: 20px;

	color: #5D5189;
	font-size: 16px;
	font-weight: 400;
	line-height: 15px;
	@media screen and (max-height: 670px) {
		font-size: 10px;
		line-height: 10px;
	}
`;

export const Bottom = styled(Space)`
	padding-top: 305px;
	padding-bottom: 16px;
	z-index: 99;
	background-color: ${(props) => props.theme.backgroundColor};
	position: fixed;
	width: 100%;
	max-width: 480px;
	gap: 16px !important;
	justify-content: center;

	.ant-space-item {
		flex: 1;

		:nth-child(1) {
			text-align: right;
			padding-inline-start: 16px;
		}

		:nth-child(2) {
			text-align: left;
			padding-inline-end: 16px;
		}
	}

	.ant-btn {
		width: 100%;
		background-color: #71207c !important;
	}

	@media screen and (max-width: 400px) {
		padding-top: 285px;
	}
`;

export const TopBgImage = styled.img.attrs({
	alt: "bg-img",
	src: SpinContainerBg,
})`
	position: fixed;
	top: 69px;
	width: 100%;
	max-width: 480px;
	height: 280px;
	z-index: 500;

	@media screen and (max-width: 350px) {
		height: 260px;
	}
	@media screen and (max-height: 650px) {
		height: 200px;
	}
	@media screen and (max-height: 582px) {
		height: 172px;
	}
`;

export const SpinnerBox = styled.div`
	width: 100%;
	position: sticky;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`;

export const OuterBadge = styled.img.attrs({
	alt: "badge",
	id: "badge-img",
	src: IMG_WHEEL_BG,
})`
	position: absolute;
	width: 260px;
	height: 260px;
	cursor: pointer;
	z-index: 200;
	top: 10px;
	margin-left: 0px;

	@media screen and (max-width: 350px) {
		width: 224px;
		height: 224px;
		margin-left: 0px;
		top: 28px;
	}
	@media screen and (max-height: 650px) {
		width: 200px;
		height: 200px;
		top: 8px;
	}
	@media screen and (max-height: 582px) {
		width: 172px;
		height: 172px;
		top: 7px;
	}
`;

export const WheelContainer = styled.div`
	position: fixed;
	width: 100%;
	max-width: 480px;
	height: 293px;
	z-index: 800;
	display: flex;
	align-items: center;
	justify-content: center;

	> div {
		width: 220px;
		height: 220px;
		transform: rotate(-53deg);
	}

	img:not(#badge-img):not(#center) {
		display: none;
	}

	@media screen and (max-width: 350px) {
		> div {
			width: 190px;
			height: 190px;
		}
	}

	@media screen and (max-height: 650px) {
		> div {
			width: 170px;
			height: 170px;
		}
		height: 220px;
	}

	@media screen and (max-height: 582px) {
		> div {
			width: 145px;
			height: 145px;
		}
		height: 195px;
	}
`;

export const Container = styled.div`
	position: relative;
	z-index: 999;
	text-align: center;
	margin-top: 350px;

	.ant-btn {
		height: 52px;
		margin-top: 24px;
		max-width: 170px;
	}
`;

export const Text = styled.div`
	padding-bottom: 10px;
	color: #49028E;
	font-size: 18px;
`;

export const SpinWrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	position: relative;
`;

export const WinnersContainer = styled.div`
	height: 100%;
	position: relative;
	overflow-y: auto;
`;

export const WinnerItem = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	align-items: flex-start;
	padding: 5px 0;
	margin-bottom: 1px;
	background-color: #F8EEFF;
	@media screen and (max-height: 670px) {
		height: 47px;
	}
`;

export const LeftSection = styled.div`
	display: flex;
	align-items: flex-start;
`;

export const PhNameWrapper = styled.div`
	padding: 12px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 3;
`;

export const NameWrapper = styled.div`
	color: #5D5189;
	font-size: 16px;
	font-weight: 400;
	line-height: 17.5px;
	@media screen and (max-height: 670px) {
		font-size: 14px;
	}
`;

export const PhoneWrapper = styled.div`
	color: #9B92BB;
	font-size: 14px;
	font-weight: 400;
	line-height: 15px;
	@media screen and (max-height: 670px) {
		font-size: 12px;
	}
`;

export const AmountWrapper = styled.div`
	padding: 12px;

	color: #49028E;
	font-size: 16px;
	font-weight: 500;
	line-height: 15px;
	@media screen and (max-height: 670px) {
		font-size: 14px;
	}
`;

export const BottomContainer = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 1000;
	margin-top: 280px;
	position: relative;
	@media screen and (max-height: 650px) {
		margin-top: 250px;
	}
	@media screen and (max-height: 582px) {
		margin-top: 205px;
	}
`;

export const TableContainer = styled.div`
	margin-top: 8px;
	height: 315px;
	width: 100%;
	z-index: 99;
	position: relative;

	/* overflow-y: hidden; */
	@media screen and (max-height: 830px) {
		height: 285px;
	}
	@media screen and (max-height: 800px) {
		height: 250px;
	}
	@media screen and (max-height: 770px) {
		height: 225px;
	}
	@media screen and (max-height: 744px) {
		height: 195px;
	}
	@media screen and (max-height: 712px) {
		height: 165px;
	}
	@media screen and (max-height: 683px) {
		height: 138px;
	}
	@media screen and (max-height: 650px) {
		height: 130px;
	}
`;

export const WinnerTitle = styled.div`
	background-color: #9027E1;
	padding: 12px 0;

	color:  #FFF;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`

export const ButtonWrapper = styled.div`
	max-width: 448px;
	height: 49.25px;
	display: flex;
	gap: 12px;
	justify-content: space-between;
	padding: 5px 0;
	margin: 0 16px;
	position: fixed;
	bottom: 12px;
	width: 100%;
	@media screen and (max-height: 650px) {
		height: 45px;
	}
	@media (max-width: 370px) {
		width: 330px;
	}
	@media (max-width: 330px) {
		width: 300px;
	}
	@media screen and (max-height: 582px) {
		bottom: 0px;
		height: 38px;
	}

	@media screen and (max-width: 460px) {
		max-width: 400px;
	}

	@media screen and (max-width: 400px) {
		max-width: 370px;
	}

	@media screen and (max-width: 370px) {
		max-width: 340px;
	}
`;

export const ButtonDiv = styled.div`
flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	font-size: ${(props) => (props.language === "MM" ? "16px" : "20px")};
	font-weight: 500;
	color: ${(props) => (props.isRule ? "#49028E" : "#FFF")};
	background-color: ${(props) => (props.isRule ? "#E5E0F5" : "#49028E")};
	border-radius: 12px;
	/* @media screen and (max-height: 582px) {
		width: 42%;
	} */
`;

export const LoadMoreWrapper = styled.div`
	text-decoration: underline;
	color: #d28a28;
	font-size: 14px;
	font-weight: 100;
	line-height: 17.5px;
	cursor: pointer;
	margin: 10px 0;
`;

export const StartButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 120px;
	height: 41px;
	border-radius: 12px;
	background-color: #49028E;

	color: #FFF;
	font-size: 16px;
	font-weight: 500;
	line-height: 26.86px;
	cursor: pointer;
	@media screen and (max-height: 582px) {
		width: 110px;
		height: 35px;
	}
`;

export const CenterIcon = styled.img.attrs((props) => ({
	id: props.id,
	src: props.src,
}))`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1000;
	width: 50px;
	height: 50px;

	@media screen and (max-width: 325px) {
		width: 40px;
		height: 40px;
	}
`;
